"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Transaction } from "@/entities/ITransaction";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { formatAddress, getProfileTargetRoute } from "@/helpers/Helpers";
import { TransactionType } from "./UserPageStatsActivityWalletTableRow";
import { usePathname } from "next/navigation";
import { USER_PAGE_TAB_IDS } from "@/components/user/layout/userTabs.config";
export default function UserPageStatsActivityWalletTableRowSecondAddress(t0) {
  const $ = _c(16);
  const {
    transaction,
    type
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [TransactionType.AIRDROPPED]: "to",
      [TransactionType.RECEIVED_AIRDROP]: "from",
      [TransactionType.SEIZED]: "",
      [TransactionType.SEIZED_TO]: "to",
      [TransactionType.SALE]: "to",
      [TransactionType.PURCHASE]: "from",
      [TransactionType.TRANSFER_IN]: "from",
      [TransactionType.TRANSFER_OUT]: "to",
      [TransactionType.BURNED]: "",
      [TransactionType.RECEIVED_BURN]: "from"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TYPE_TO_ACTION = t1;
  let t2;
  if ($[1] !== transaction || $[2] !== type) {
    t2 = () => {
      switch (type) {
        case TransactionType.SEIZED:
        case TransactionType.PURCHASE:
        case TransactionType.TRANSFER_IN:
        case TransactionType.RECEIVED_BURN:
        case TransactionType.RECEIVED_AIRDROP:
          {
            return {
              display: transaction.from_display ?? formatAddress(transaction.from_address) ?? "unknown",
              address: transaction.from_address
            };
          }
        case TransactionType.AIRDROPPED:
        case TransactionType.SALE:
        case TransactionType.BURNED:
        case TransactionType.TRANSFER_OUT:
        case TransactionType.SEIZED_TO:
          {
            return {
              display: transaction.to_display ?? formatAddress(transaction.to_address) ?? "unknown",
              address: transaction.to_address
            };
          }
        default:
          {
            assertUnreachable(type);
            return {
              display: "",
              address: ""
            };
          }
      }
    };
    $[1] = transaction;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getWalletDisplayAndAddress = t2;
  let display;
  let t3;
  if ($[4] !== getWalletDisplayAndAddress || $[5] !== pathname) {
    const {
      display: t4,
      address
    } = getWalletDisplayAndAddress();
    display = t4;
    t3 = getProfileTargetRoute({
      handleOrWallet: address,
      pathname: pathname ?? "",
      defaultPath: USER_PAGE_TAB_IDS.STATS
    });
    $[4] = getWalletDisplayAndAddress;
    $[5] = pathname;
    $[6] = display;
    $[7] = t3;
  } else {
    display = $[6];
    t3 = $[7];
  }
  const path = t3;
  const t4 = TYPE_TO_ACTION[type];
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="tw-text-iron-400">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== display || $[11] !== path) {
    t6 = <Link href={path} className="tw-text-iron-100 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out">{display}</Link>;
    $[10] = display;
    $[11] = path;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <span className="tw-inline-flex tw-space-x-1">{t5}{t6}</span>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}